import { RewardType } from "types/business/RewardType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RewardType[];

export const useDefaultObservableRewardTypeArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRewardTypeArray extends BehaviorSubject<CurrentType> {}
